import {Expressions, Variable} from '@packages/systems/wfdl';
import type {Expression} from '@packages/systems/wfdl-ast';

const triggerRegex = /^CMS\sTrigger:\s(.+)\s(updated)$/;
const blockRegex = /^(Update|Delete|Create|Lookup)\s(.+)$/;

/**
 * Strips the plugin-specific name (like Update, Create, CMS Trigger) and returns
 * the specific collect name as it stored in the actual collection
 */
export function getCollectionPluginValueName(name: string): string {
  const isCmsTrigger = name.startsWith('CMS Trigger');
  return name.replace(
    isCmsTrigger ? triggerRegex : blockRegex,
    isCmsTrigger ? '$1' : '$2'
  );
}

/**
 * Strips the plugin-specific name (like Update, Create, CMS Trigger) and returns
 * the specific collect name as it stored in the actual collection
 */
export function getCollectionNameFromVariable(expr: Expression): string | null {
  const variable = Expressions.getVariable(expr);
  const variableName = variable ? Variable.getName(variable) : null;
  return variableName ? getCollectionPluginValueName(variableName) : null;
}
